// ** React imports
import React from 'react';

// ** Third party
import { Card, CardBody, Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

// ** Components
import SecondaryButton from '../../../../components/examod/buttons/secondaryButton';

// ** Navigator
import { navigateToLogin } from '../../../../Navigator';

// ** Assets
import errorImg from '../../../../assets/img/pages/fe-based-error.png';
import './../../../../assets/scss/pages/fe-based-error.scss';

const FeBasedError = ({ loginErrorTitle, loginErrorMessage }) => {
  return (
    <div className="error-page-fe">
      <img
        className="background-images-fe"
        src={require('../../../../assets/img/pages/error-page-top-left-cloud.svg')}
        alt="error-page-left-cloud"
        style={{ position: 'absolute', top: '0', left: '0' }}
      />
      <img
        className="background-images-fe"
        src={require('../../../../assets/img/pages/error-page-top-right-image.svg')}
        alt="error-page-mountain-and-sun"
        style={{ position: 'absolute', top: '0', right: '0' }}
      />
      <img
        className="background-images-fe"
        src={require('../../../../assets/img/pages/error-page-bottom-right-cloud.svg')}
        alt="error-page-right-cloud"
        style={{ position: 'absolute', bottom: '0', right: '0' }}
      />
      <Row className="m-0">
        <Col sm="12">
          <Card className="auth-card bg-transparent shadow-none rounded-0 mb-0 w-100 d-flex justify-content-center align-items-center">
            <CardBody className="error-page-container-fe text-center">
              <img
                src={errorImg}
                alt="ErrorImg"
                className="img-fluid align-self-center"
              />
              <div className="error-title-fe">
                <FormattedMessage
                  id={loginErrorTitle || 'feBasedError.title'}
                  values={{
                    color: (chunks) => (
                      <span className="span-examod">{chunks}</span>
                    ),
                  }}
                />
              </div>
              <div className="error-description-fe">
                {loginErrorMessage || (
                  <FormattedMessage id="feBasedError.desc" />
                )}
              </div>
              {loginErrorMessage ? (
                <SecondaryButton
                  className="redirect-error-button"
                  type="button"
                  textId="login.toLogin"
                  onClick={() => {
                    navigateToLogin();
                  }}
                />
              ) : null}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default FeBasedError;
